import {GET_DESIGN_DATA} from "../constants";

export const getDesignData = (requestObj: any): any => ({
    type: GET_DESIGN_DATA,
    requestObj,
});
